export default __webpack_public_path__ + "static/media/Browse.0f82a5c9.svg";